import {doc} from "./docs.js";
import SubPatch from "zobject/SubPatch.js";
import InstancedSubPatch from "zobject/InstancedSubPatch.js";

doc(
    "subpatch",
    {
        "name": "Name of the subpatch"
    },
    "Creates an encapsulated patcher",
    () => 0,
    {
        inlets: [],
    }
);
export const subpatch = (object, name) => {
    // instantiate the subpatch object
    let patch = new SubPatch(object.subSequence, object.sequencerEngine, object, name);
    object.effect = patch;
    object.isSubPatch = true;

    return () => {
    };
}

doc(
    "instancedSubpatch",
    {
    },
    "Creates an encapsulated patcher",
    () => 0,
    {
        inlets: [],
    }
);

export const instancedSubpatch = (object) => {
    // instantiate the subpatch object
    let patch = new InstancedSubPatch(object.subSequence, object.sequencerEngine, object);
    object.effect = patch;
    object.isSubPatch = true;

    return () => {
    };
}


